import styled from "styled-components";
import Header from "../Header";
import Hero from "../Hero";
import { useEffect } from "react";
const Partner = () => {

    useEffect(()=>{
        window.scrollTo(0,0)
      },[])
    return(
        <>
            <Header/>
            <Banner>
                <div className="banner__container">
                    <div className="banner__content">
                        <h2>Invest With Us</h2>
                        <p>Create the future you deserve (wealth and happiness).Share in the dream of winnthako, your safest and reliable  platform of investment.</p>
                    </div>
                    <div className="banner__background"></div>
                </div>
            </Banner>

            <Container>
                <Content>
                    An investment platform committed to discourage poverty and promote wealth creation. Where your money invested is traded and returned to you with an interest added depending on the time period invested.
                    Please Note: In a case of default or recovery before maturing, a 20% deduction will be made from the "<b>initial</b>" capital. And (in a case of default, please a one week notification must be given)
                    <br/>

                    <b>Please Note: This is not a ponzi scheme, it's an investment platform</b>

                    <p>Having read and accepted the terms and conditions of this invested policy, I accept to continue with my investment.</p>

                    <div>Please find below our investments Policies</div>

                    <h3>Types of Policy</h3>
                    <ul>
                        <li>Monthly(Amateur): 5% returns</li>
                        <li>Half A year(Master): 40% returns</li>
                        <li>One year(Professional): 100% returns</li>
                    </ul>
                    To be a part of our investment platform, Please send a mail to <b>winnthako@gmail.com</b> 
                </Content>
            </Container>
        </>
    )
}

const Container = styled.div`
    max-width: 80%;
    margin: 100px auto;
`
const Content = styled.div`

`

const Banner = styled.div`
    .banner__container{
        color: rgb(255, 255, 255);
        display: flex;
        flex-direction: column;
        z-index: 1;
        position: relative;
        background: black;
        overflow: hidden;

        p{
            color: rgb(255, 255, 255);
        }
    }

    .banner__background{
        background: linear-gradient(rgba(0,0,0,0.3),rgba(0,0,0,0.3)), url("/images/gallery/about1.jpg");
        background-size: cover;
        background-position-x: center;

        background-attachment: fixed;
        position: absolute;
        opacity: 0.3;
        top: 0;
        height: 100%;
        width: 100vw;
        z-index: -1;

    }
    
    .banner__content{
        color: rgb(255, 255, 255);
        max-width: 80%;
        padding: 10% 20px;
        p{
            color: rgb(255, 255, 255);
        }
    }
    
`

export default Partner
